<template>
  <div>
    <h2>My Site Information</h2>
    <div>
      <div
        v-if="isAdmin || isWithMultipleOwners"
        class="e-card-content"
        style="display: flex; width: 50%; padding-left: 10px"
      >
        <ejs-autocomplete
          ref="userProfileRef"
          :dataSource="owners"
          placeholder="Site Owner"
          :fields="{ value: 'ownerFullInfo' }"
          :minLength="3"
          sortOrder="Ascending"
          filterType="Contains"
          float-label-type="Always"
          :change="onUserSelection"
          cssClass="e-static-clear"
          :value="defaultOwnerString"
          v-if="isAdmin"
        />
        <!-- :value="defaultOwner" -->
        <ejs-dropdownlist
          ref="userDropdownProfileRef"
          :dataSource="myOwners"
          placeholder="Site Owner"
          :fields="{ value: 'ownerFullInfo' }"
          :minLength="3"
          sortOrder="Ascending"
          filterType="Contains"
          float-label-type="Always"
          :change="onUserSelection"
          cssClass="e-static-clear"
          :value="defaultOwnerString"
          v-if="isWithMultipleOwners"
        />

        <button
          style="margin: 10px"
          @click="reOpenButtonClick"
          v-if="siteReviewStatus"
          class="e-control e-btn e-lib e-info"
        >
          Reopen
        </button>
      </div>
      <fieldset
        v-if="
          ownerInfo.ownerId ||
          ownerInfo.ownerContact ||
          ownerInfo.ownerFullAddress ||
          ownerInfo.ownerDetail
        "
      >
        <legend><span style="color: #0f4b90; font-weight: 800">Owner Details</span></legend>
        <div v-if="ownerInfo.ownerId" style="padding: 5px">
          <b>Owner #: </b>
          {{ ownerInfo.ownerId }}
        </div>
        <div v-if="ownerInfo.ownerContact" style="padding: 5px">
          <b>Owner Name: </b>
          {{ ownerInfo.ownerName }}
        </div>
        <div v-if="ownerInfo.ownerContact" style="padding: 5px">
          <b>Contact: </b>
          {{ ownerInfo.ownerContact }}
        </div>
        <div v-if="ownerInfo.ownerFullAddress" style="padding: 5px">
          <b>Owner Address: </b>
          {{ ownerInfo.ownerFullAddress }}
        </div>
        <div v-if="ownerInfo.ownerDetail" style="padding: 5px">
          <b>Owner Details: </b>
          {{ ownerInfo.ownerDetail }}
        </div>
      </fieldset>
    </div>
    <div class="e-card" id="basic">
      <div class="e-card-content">
        <ejs-tab
          id="collapsible_tab"
          class="e-background"
          ref="refTabInstance"
          :created="tabCreated"
          :selecting="tabSelect"
        >
          <e-tabitems>
            <e-tabitem :header="headerText0" :content="content0"></e-tabitem>
            <e-tabitem :header="headerText1" :content="content1"></e-tabitem>
            <e-tabitem :header="headerText2" :content="content2"></e-tabitem>
            <e-tabitem :header="headerText3" :content="content3"></e-tabitem>
          </e-tabitems>
        </ejs-tab>
      </div>
    </div>
    <div id="operationalPermitList">
      <operational-permit-list
        :isSiteReviewReadyData="isSiteReviewReadyData"
        :documentsDS="documentsDS"
        :showReview="showReview"
        :comments="comments"
        :ownerInfo="ownerInfo"
        :mySitesDS="mySitesDS"
      />
    </div>
    <div id="siteList" style="display: none">
      <operational-permit-list
        ref="refOperationalPermitList"
        :showAllSites="true"
        :mySitesDS="mySites"
        :ownerInfo="ownerInfo"
        :isSiteReviewReadyData="isSiteReviewReadyData"
      />
    </div>
    <div id="siteDetails" style="display: none">
      <site-details
        ref="refSiteDetails"
        :comments="comments"
        :siteId="siteId"
        :isSiteReviewReadyData="isSiteReviewReadyData"
        :showReview="showReview"
        :ownerInfo="ownerInfo"
      />
    </div>
    <div id="review" style="display: none">
      <site-review
        ref="reviewRef"
        :comments="comments"
        :documentsDS="documentsDS"
        :ownerInfo="ownerInfo"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { TabPlugin } from "@syncfusion/ej2-vue-navigations";
import { DialogUtility } from "@syncfusion/ej2-popups";
import { mapActions, mapGetters } from "vuex";
// import { off } from "process";
import SiteDetails from "../components/site-details.vue";
// import { FETCH_LOGGED_USER } from "../../auth/store";
import SiteReview from "../components/site-review.vue";
import {
  isSiteReviewReady,
  saveSiteReviewData,
  reopenReviewData,
} from "../services/site-eservices-api";
import OperationalPermitList from "../components/operational-permit-list.vue";
import { FETCH_MY_SITES, SET_SELECTED_OWNER, SET_MY_SITES } from "../store";
import { FETCH_SITE_OWNERS } from "../../settings/store";
// import { created } from '@syncfusion/ej2-vue-grids';

Vue.use(TabPlugin);

let DialogObj;

export default {
  components: {
    SiteDetails,
    SiteReview,
    OperationalPermitList,
  },
  data() {
    return {
      headerText0: { text: " Operating Permit List " },
      headerText1: { text: " Site List " },
      headerText2: { text: " Site Details " },
      headerText3: { text: " Review " },
      content0: "#operationalPermitList",
      content1: "#siteList",
      content2: "#siteDetails",
      content3: "#review",
      siteId: null,
      documentsDS: [],
      showReview: false,
      comments: [],
      isSiteReviewReadyData: null,
      ownerInfo: {},
      changedComments: null,
      loading: true,
      isWithMultipleOwners: false,
      myOwners: [],
    };
  },
  watch: {
    loggedUser() {
      this.checkUserRole();
      if (!this.isAdmin) {
        // -- check user owners
        let { email } = this.loggedUser;
        let contactId = 0;
        let ownerId = 0;
        let requestId = '';
        if (this.defaultOwner) {
          ownerId = this.defaultOwner.ownerID;
          email = this.defaultOwner.emailAddress;
          requestId = this.defaultOwner.requestId;
          if (ownerId) {
            contactId = this.defaultOwner.ownerContactID;
          }
        }
        this.checkIfSiteReviewReady(email, ownerId, contactId, requestId);
      }
    },
    showReview(showReview) {
      this.controlNavigationToReview(showReview);
    },
  },
  computed: {
    ...mapGetters({
      mySites: "mySites",
      loggedUser: "loggedUser",
      selectedOwner: "selectedOwner",
      owners: "owners",
    }),
    defaultOwner() {
      return this.selectedOwner;
    },
    defaultOwnerString() {
      return this.selectedOwner ? this.selectedOwner.ownerFullInfo : '';
    },
    siteReviewStatus() {
      return (
        this.isSiteReviewReadyData?.siteReviewStatus?.toLowerCase() === "submit for review"
        && this.isAdmin
        // && this.showReopenButton
      );
    },
    mySitesDS() {
      if (this.mySites) {
        const filterSites = [...this.mySites.filter((x) => x.isReadyForCertify === true)];
        filterSites.forEach((site) => {
          // eslint-disable-next-line no-param-reassign, no-cond-assign
          if ((site.registration_Status = site.registration_Status !== "Exempt")) {
            // eslint-disable-next-line no-param-reassign
            site.registration_Status = site.registration_Status === "NotRegistered" ? "Invalid" : "valid";
          }
        });
        return filterSites;
      }
      return null;
    },
    isAdmin() {
      if (this.loggedUser) {
        const roles = this.loggedUser.roles.map((x) => x.roleName);
        return roles.includes("Admin") || roles.includes("SuperAdmin");
      }
      return false;
    },
  },
  async created() {
    if (this.loggedUser) {
      // const roles = this.loggedUser.roles.map((x) => x.roleName);
      // this.isAdmin = roles.includes('Admin') || roles.includes('SuperAdmin');
      await this.fetchSiteOwners();

      const { email } = this.loggedUser;
      if (this.isAdmin) {
        // this.myOwners = this.owners;
      } else if (email && this.owners) {
        this.myOwners = this.owners.filter(
          // -- firstEmail already convert to lower in database view.
          (item) => item.firstEmail === email.toLowerCase(),
        );
        if (this.myOwners.length > 1) {
          this.isWithMultipleOwners = true;
          if (!this.defaultOwner) {
            await this.$store.commit(SET_SELECTED_OWNER, this.myOwners[0]);
          }
        }
      }
      await this.checkUserRole();
    }
  },
  methods: {
    ...mapActions({
      /** This is commented out when the page level authorization is implemented. Todo: Refactor */
      // fetchUser: FETCH_LOGGED_USER,
      fetchSites: FETCH_MY_SITES,
      fetchSiteOwners: FETCH_SITE_OWNERS,
    }),
    reOpenButtonClick() {
      this.showpopup(
        "reopen",
        "Are you sure you want to reopen site review?",
        "Reopen Site Review",
      );
    },
    showpopup(functionName, content, title) {
      DialogObj = DialogUtility.confirm({
        title,
        content,
        okButton: { text: "OK", click: this[functionName] },
        cancelButton: { text: "Cancel", click: this.hideDeleteDialog },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" },
      });
    },
    hideDeleteDialog() {
      DialogObj.hide();
    },
    async reopen() {
      this.hideDeleteDialog();
      try {
        const email = this.$refs.userProfileRef.$el.value.split(",")[2].trim();
        const ownerId = this.$refs.userProfileRef.$el.value.split(",")[0].trim();
        const contacts = this.$refs.userProfileRef.$el.value.split(",")[1].trim();
        let { requestId } = this.defaultOwner ? this.defaultOwner : '';
        if (!requestId) { requestId = this.isSiteReviewReadyData ? this.isSiteReviewReadyData.applicationRequestId : '' }
        let contactId = 0;
        if (contacts) {
          const contactIdStr = contacts.split("(")[1].trim();
          if (contactIdStr) {
            contactId = contactIdStr.replace(")", "");
          }
        }
        await reopenReviewData(email, ownerId, contactId, requestId).then((res) => {
          this.isSiteReviewReadyData = res.data;
          this.notify("Success !", "Review Opened Successfully");
          this.showReopenButton = false;
        });
      } catch (err) {
        this.notify("Error !", "Error occurred while reopening review");
      }
    },
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error !' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    async onUserSelection(e) {
      if (e.e !== undefined) {
        if (!e.itemData) {
          this.showReopenButton = false;
          // this.mySitesDS = null;
          this.ownerInfo = {};
          this.isSiteReviewReadyData = {};
          await this.$store.commit(SET_SELECTED_OWNER, null);
          await this.$store.commit(SET_MY_SITES, { mysites: null });
        } else {
          await this.$store.commit(SET_SELECTED_OWNER, e.itemData);
          this.$refs.refTabInstance.select(0);
          this.$refs.refTabInstance.enableTab(2, false);

          const ownerId = e.itemData.ownerID;
          const email = e.itemData.emailAddress;
          if (ownerId) {
            const contactId = e.itemData.ownerContactID;
            this.mySiteDSData(email, ownerId, contactId);
          } else if (email && email !== "null") {
            this.mySiteDSData(email, 0, 0);
          }
          this.showReopenButton = true;
        }
      }
    },
    async checkUserRole() {
      if (this.loggedUser) {
        if ((this.isAdmin && this.defaultOwner) || this.defaultOwner) {
          const ownerId = this.defaultOwner.ownerID;
          const email = this.defaultOwner.emailAddress;
          const { requestId } = this.defaultOwner;
          if (ownerId) {
            const contactId = this.defaultOwner.ownerContactID;
            this.mySiteDSData(email, ownerId, contactId, requestId);
          } else if (email && email !== "null") {
            this.mySiteDSData(email, 0, 0, requestId);
          }
        } else if (!this.isAdmin) {
          this.mySiteDSData(this.loggedUser.email, 0, 0);
        } else {
          await this.$store.commit(SET_MY_SITES, { mysites: null });
          await this.fetchSiteOwners();
        }
      }
    },
    async mySiteDSData(userEmail, sownerId, sownerContactId, requestId = null) {
      this.ownerInfo = {};
      this.isSiteReviewReadyData = {};
      this.loading = true;
      if (userEmail || (sownerId && sownerContactId)) {
        await this.checkIfSiteReviewReady(userEmail, sownerId,
          sownerContactId, requestId, this.$refs?.documentsGrid);
        const regId = this.isSiteReviewReadyData.tmsRegistrationId
          ? this.isSiteReviewReadyData.tmsRegistrationId : 0;
        await this.fetchSites({
          userEmail, ownerId: sownerId, ownerContactId: sownerContactId, regId,
        });
      }
      if (this.mySites !== null && this.mySites.length > 0) {
        const ownerContact = this.mySites[0].owner_Contact;
        const ownerFullAddress = this.mySites[0].owner_Address;
        const ownerId = this.mySites[0].owner_Id;
        const ownerDetail = this.mySites[0].owner_Detail;
        const ownerName = this.mySites[0].owner_Name;
        let ownerEmail = null;
        if (this.defaultOwner) {
          this.showReopenButton = true;
          ownerEmail = this.defaultOwner.emailAddress;
        } else if (!this.isAdmin) {
          ownerEmail = this.loggedUser.email;
        }

        const ownerContactId = this.mySites[0].ownerContactID;
        this.ownerInfo = {
          ownerContact,
          ownerFullAddress,
          ownerId,
          ownerDetail,
          ownerEmail,
          ownerContactId,
          ownerName,
        };
        this.showFooter = this.isSiteReviewReadyData !== null;
      } else {
        this.showFooter = false;
      }
      this.loading = false;
    },
    checkIfCommentsChange(comments, siteId) {
      const exisitingSite = this.comments.find((x) => x.siteId === siteId);
      this.changedComments = comments;
      this.siteId = siteId;
      if (exisitingSite) {
        if(comments){
          exisitingSite.comments = this.changedComments;
          exisitingSite.isEdited = true;
        }else{
          this.comments.splice(exisitingSite);
        }
      } else {
        if(comments){
          this.comments.push({
          siteId: this.siteId,
          comments: this.changedComments,
          isEdited: true,
          });
        }        
      }
      this.showReview = this.comments.length > 0 || this.documentsDS.length > 0;
      this.controlNavigationToReview(this.showReview);
    },
    tabCreated() {
      this.controlNavigationToReview(this.showReview);
      this.controlNavigationToDetail(false);
      // this.controlNavigationToListView(this.isSiteReviewReadyData !== null);
    },
    async tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      } else {
        this.onIndexChange();
      }
    },
    // eslint-disable-next-line max-len
    async checkIfSiteReviewReady(userEmail, ownerId, ownerContactId, requestId, documentsGrid = null) {
      let tRequestId = requestId;
      if (!requestId) {
        tRequestId = '00000000-0000-0000-0000-000000000000';
      }
      await isSiteReviewReady(userEmail, ownerId, ownerContactId, tRequestId)
        .then((res) => {
          this.isSiteReviewReadyData = res.data;
          if (this.isSiteReviewReadyData?.siteReviewDocuments) {
            this.documentsDS = this.isSiteReviewReadyData?.siteReviewDocuments.map(
              (x) => x.document,
            );
          }

          if (this.isSiteReviewReadyData?.siteReviews) {
            this.isSiteReviewReadyData.siteReviews.forEach((review) => {
              if (review.comments?.length > 0) {
                this.comments.push({
                  comments: review.comments,
                  siteId: review.siteId,
                  isEdited: false,
                });
              }
            });
          }
          this.showReview = this.comments.length > 0 || this.documentsDS.length > 0;
          // eslint-disable-next-line no-unused-expressions
          documentsGrid?.refresh();
          this.loading = false;
          this.$refs.refTabInstance.ej2Instances.items[0].visible = true;
          this.$refs.refTabInstance.ej2Instances.items[3].visible = true;
          this.$refs.refTabInstance.select(0);
        })
        .catch(() => {
          this.$refs.refTabInstance.ej2Instances.items[0].visible = false;
          this.$refs.refTabInstance.ej2Instances.items[3].visible = false;
          this.$refs.refTabInstance.select(1);
        });
    },
    onIndexChange() {
      const site = this.comments.find((x) => x.isEdited === true);
      if (site?.isEdited) {
        let requestId = this.defaultOwner ? this.defaultOwner.requestId : '';        
        if (!requestId) { requestId = this.isSiteReviewReadyData ? this.isSiteReviewReadyData.applicationRequestId : ''; }
        this.saveComments({
          ownerId: this.mySites[0].owner_Id,
          ownerContactId: this.mySites[0].ownerContactID,
          comments: site.comments,
          siteId: site.siteId,
          requestId,
        });
      }
    },
    async saveComments(data) {
      await saveSiteReviewData(data).then((res) => {
        this.comments.find((x) => x.siteId === data.siteId).isEdited = false;
        if (res.data && res.data.siteReviews && res.data.siteReviewDocuments) {
          this.showReview = res.data.siteReviews.length > 0
          || res.data.siteReviewDocuments.length > 0;
        } else {
          this.showReview = false;
        }
      });
    },
    controlNavigationToReview(enableNavigation) {
      this.$refs.refTabInstance.enableTab(3, enableNavigation);
    },
    controlNavigationToListView(enableNavigation) {
      this.$refs.refTabInstance.enableTab(0, enableNavigation);
    },
    controlNavigationToDetail(enableNavigation) {
      this.$refs.refTabInstance.enableTab(2, enableNavigation);
    },
    parentSiteClicked(siteId) {
      this.siteId = siteId;
      this.controlNavigationToDetail(true);
      document.getElementById("collapsible_tab").ej2_instances[0].select(2);
    },
  },
};
</script>
<style>
.e-card-content {
  margin: 0% !important;
}
.sumary-header {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  font-size: small;
  padding: 1px 1px 5px 1px;
}
.container_site {
  padding: 16px 25 16px 25;
  min-width: 80%;
}

.wrap {
  box-sizing: border-box;
  margin: 0 auto;
  padding: 2px 2px;
  width: 95%;
}

#loader {
  color: #008cff;
  height: 40px;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 30%;
}

.e-content .e-item {
  font-size: 12px;
  margin: 10px;
  text-align: justify;
}
.container_userinfo {
  min-width: 80%;
  margin: 0 10px;
}

.info {
  margin: 10px;
  font-weight: bold;
}

.e-tab .e-content > .e-item.e-active.collapse {
  display: none;
}

.e-tab .e-tab-header .e-indicator.collapse {
  display: none;
}
.e-tab.e-background .e-tab-header {
  background: #0f4b90;
  border: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap {
  background: #0f4b90;
  border-radius: 0;
}
.e-tab.e-background .e-tab-header .e-toolbar-item .e-tab-wrap {
  background: #0f4b90 !important;
}
.e-tab.e-background .e-tab-header .e-toolbar-item.e-active .e-tab-wrap:focus {
  background: #0f4b90;
}
fieldset {
  border: 1px solid lightgray;
}
fieldset {
  border: 1px solid lightgray;
  font-size: 12px;
}
</style>
